export default __webpack_public_path__ + "static/media/human-respiratory.e89364e3.svg";